import classNames from 'classnames/bind';
import { ReactNode } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export enum Shape {
  ROUND = 'round',
  SQUARE = 'square',
}

interface IProps {
  block?: boolean;
  children: ReactNode;
  className?: string;
  isChecked: boolean;
  shape: Shape;
  clickCode: string;
  onChange: (value?: any) => void;
}

export default function Checkbox({
  block = false,
  children,
  className,
  isChecked,
  shape,
  clickCode,
  onChange,
}: IProps) {
  return (
    <button
      type="button"
      aria-checked={isChecked}
      className={cx('Checkbox', className)}
      role="checkbox"
      data-block={block}
      data-shape={shape}
      data-event-nlog="click"
      data-event-area-code={clickCode}
      onClick={onChange}
    >
      {children}
    </button>
  );
}
